import _ from "lodash";

export const range = (from, to, inclusive) =>
  [...Array(to - from + (inclusive ? 1 : 0)).keys()].map(n => from + n);

export const splicePure = (array, start, amount, newElements) => [
  ...array.slice(0, start + 1),
  ...newElements,
  ...array.slice(start + amount)
];

export const uniqBy = (items, propName) => {
  const itemMap = items.reduce((mapItem, item) => {
    if (mapItem.hasOwnProperty(item[propName])) {
      return mapItem;
    }
    return {
      ...mapItem,
      [item[propName]]: item
    };
  }, {});
  return Object.values(itemMap);
};

export const sortBy = (items, propName, desc = false) => {
  const newItems = [...items];
  newItems.sort((a, b) => {
    if (a[propName] > b[propName]) {
      return 1;
    }
    if (a[propName] < b[propName]) {
      return -1;
    }
    return 0;
  });
  if (desc) {
    newItems.reverse();
  }
  return newItems;
};

export const getYesNo = (options, propName) => {
  const optionsYesNo = sortBy(uniqBy(options, "name"), "name", true);
  return propName ? optionsYesNo.map(o => o[propName]) : optionsYesNo;
};

export const getYes = (options, propName) => getYesNo(options, propName)[0];

export const getNo = (options, propName) => getYesNo(options, propName)[1];

export const removeParam = (field, param) => {
  return {
    ...field,
    params: field.params
      .split("|")
      .filter(p => p !== param)
      .join("|")
  };
};

export const mapKeysDeep = (obj, cb, isRecursive) => {
  if (!obj && !isRecursive) {
    return {};
  }

  if (!isRecursive) {
    if (
      typeof obj === "string" ||
      typeof obj === "number" ||
      typeof obj === "boolean"
    ) {
      return {};
    }
  }

  if (Array.isArray(obj)) {
    return obj.map(item => mapKeysDeep(item, cb, true));
  }

  if (!_.isPlainObject(obj)) {
    return obj;
  }

  const result = _.mapKeys(obj, cb);

  return _.mapValues(result, value => mapKeysDeep(value, cb, true));
};

export const createActionTypes = (type, ...props) =>
  props.reduce((acc, prop) => ({ ...acc, [prop]: `${type}/${prop}` }), {});
